import React from "react";
import {
  Button,
  Iconography,
  IconographySizes,
  IconographyThemes,
  Loader,
  LoaderSizes,
} from "@hid-galaxy-ui/galaxy-react";
import { useAppDispatch, useAppSelector } from "../../../redux";
import moment from "moment";
import "./NotificationPopper.scss";
import { getAllPartnersSagaAction } from "../../../redux/saga/partner-details/saga-actions";

const NotificationPopper = () => {
  const { notificationList, status } = useAppSelector(
    (state) => state.notification
  );
  const { allPartners } = useAppSelector((state) => state.partner_details);
  const dispatch = useAppDispatch();
  const shopifyAdminURL = process.env.REACT_APP_SHOPIFY_ADMIN_LINK;

  React.useEffect(() => {
    if (!allPartners.length) dispatch(getAllPartnersSagaAction());
  }, []);

  return (
    <div className="notification-popper-container">
      <h1 className="title">Notifications</h1>
      {status.notificationListLoading ? (
        <div
          style={{ padding: "32px", display: "flex", justifyContent: "center" }}
        >
          <Loader variant={LoaderSizes.large} />
        </div>
      ) : (
        <div className="gray-box">
          {notificationList.length === 0 ? (
            <div className="no-notification">No Notifications</div>
          ) : (
            <>
              {notificationList.map((notification, index: number) => {
                const partnerName = allPartners?.find(
                  (partner) => partner.ID === Number(notification.partner_id)
                )?.partner_name;
                return (
                  <div
                    className="notification-order"
                    key={notification.ID}
                    style={index === 0 ? { border: "none" } : {}}
                  >
                    {/* <Iconography
                      icon="bell"
                      theme={IconographyThemes.Info}
                      size={IconographySizes.Medium}
                    /> */}
                    <div className="text-box">
                      <p className="line-1">{notification.message}</p>
                      <p className="line-2">
                        <span>{partnerName ? `${partnerName} - ` : ""}</span>
                        {moment(notification.type_date).format(
                          "DD/MM/YYYY - HH:mm"
                        )}
                      </p>
                    </div>
                    <Button
                      variant="secondary"
                      label="Open to Manage"
                      icon={<Iconography icon="arrowUpRightFromSquare" />}
                      onClick={() => {
                        window.open(
                          `${shopifyAdminURL}/orders/${notification.type_id}`,
                          "_blank"
                        );
                      }}
                    />
                  </div>
                );
              })}
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default NotificationPopper;
